import { desktopAlto, desktopAltoBrio, desktopBallad, desktopBalladBold, desktopBass, desktopBrio, desktopCanon, desktopCello, desktopCelloCanon, desktopFinale, desktopFinaleBold, desktopForte, desktopMesto, desktopMestoBold, desktopMetronome, desktopMinuet, desktopMinuetBold, desktopViola, desktopViolaBold, mobileAlto, mobileAltoBrio, mobileBallad, mobileBalladBold, mobileBass, mobileBrio, mobileCanon, mobileCello, mobileCelloCanon, mobileFinale, mobileFinaleBold, mobileForte, mobileMesto, mobileMestoBold, mobileMetronome, mobileMinuet, mobileMinuetBold, mobileViola, mobileViolaBold, screenSmMin } from '@spotify-internal/encore-foundation';
import { css } from "../../styled-components.mjs";
var responsiveVariant = function responsiveVariant(mobileToken, desktopToken) {
  var isSizeDifferent = mobileToken.fontSize !== desktopToken.fontSize;
  var isWeightDifferent = mobileToken.fontWeight !== desktopToken.fontWeight;
  var isTransformDifferent = mobileToken.textTransform !== desktopToken.textTransform;
  var isLetterSpacingDifferent = mobileToken.letterSpacing !== desktopToken.letterSpacing;
  var isFamilyDifferent = mobileToken.fontFamily !== desktopToken.fontFamily;
  var isDesktopDifferent = isSizeDifferent || isWeightDifferent || isFamilyDifferent || isTransformDifferent || isLetterSpacingDifferent;
  return css(["font-size:", ";font-weight:", ";text-transform:", ";letter-spacing:", ";font-family:var(--font-family,", ");", ";"], mobileToken.fontSize, mobileToken.fontWeight, mobileToken.textTransform, mobileToken.letterSpacing, mobileToken.fontFamily, /* only apply desktop styles if they differ from mobile ones */
  isDesktopDifferent && css(["@media (min-width:", "){font-size:", ";font-weight:", ";font-family:", ";text-transform:", ";letter-spacing:", ";}"], screenSmMin, isSizeDifferent && desktopToken.fontSize, isWeightDifferent && desktopToken.fontWeight, isFamilyDifferent && "var(--font-family, ".concat(desktopToken.fontFamily, ")"), isTransformDifferent && desktopToken.textTransform, isLetterSpacingDifferent && desktopToken.letterSpacing));
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "headlineLarge" variant, or add the classname "encore-text-headline-large"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('headlineLarge')};
 * ```
 */
export var bass = function bass() {
  return responsiveVariant(mobileBass, desktopBass);
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "headlineMedium" variant, or add the classname "encore-text-headline-medium"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('headlineMedium')};
 * ```
 */
export var forte = function forte() {
  return responsiveVariant(mobileForte, desktopForte);
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "titleLarge" variant, or add the classname "encore-text-title-large"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('titleLarge')};
 * ```
 */
export var brio = function brio() {
  return responsiveVariant(mobileBrio, desktopBrio);
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "titleMedium" variant, or add the classname "encore-text-title-medium"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('titleMedium')};
 * ```
 */
export var alto = function alto() {
  return responsiveVariant(mobileAlto, desktopAlto);
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "titleLarge" variant, or add the classname "encore-text-title-large"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('titleLarge')};
 * ```
 */
export var altoBrio = function altoBrio() {
  return responsiveVariant(mobileAltoBrio, desktopAltoBrio);
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "titleSmall" variant, or add the classname "encore-text-title-small"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('titleSmall')};
 * ```
 */
export var canon = function canon() {
  return responsiveVariant(mobileCanon, desktopCanon);
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "bodyMediumBold" variant, or add the classname "encore-text-body-medium-bold"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('bodyMediumBold')};
 * ```
 */
export var cello = function cello() {
  return responsiveVariant(mobileCello, desktopCello);
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "titleSmall" variant, or add the classname "encore-text-title-small"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('titleSmall')};
 * ```
 */
export var celloCanon = function celloCanon() {
  return responsiveVariant(mobileCelloCanon, desktopCelloCanon);
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "bodyMedium" variant, or add the classname "encore-text-body-medium"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('bodyMedium')};
 * ```
 */
export var ballad = function ballad() {
  return responsiveVariant(mobileBallad, desktopBallad);
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "bodyMediumBold" variant, or add the classname "encore-text-body-medium-bold"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('bodyMediumBold')};
 * ```
 */
export var balladBold = function balladBold() {
  return responsiveVariant(mobileBalladBold, desktopBalladBold);
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "bodySmall" variant, or add the classname "encore-text-body-small"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('bodySmall')};
 * ```
 */
export var viola = function viola() {
  return responsiveVariant(mobileViola, desktopViola);
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "bodySmallBold" variant, or add the classname "encore-text-body-small-bold"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('bodySmallBold')};
 * ```
 */
export var violaBold = function violaBold() {
  return responsiveVariant(mobileViolaBold, desktopViolaBold);
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "bodySmall" variant, or add the classname "encore-text-body-small"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('bodySmall')};
 * ```
 */
export var mesto = function mesto() {
  return responsiveVariant(mobileMesto, desktopMesto);
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "bodySmallBold" variant, or add the classname "encore-text-body-small-bold"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('bodySmallBold')};
 * ```
 */
export var mestoBold = function mestoBold() {
  return responsiveVariant(mobileMestoBold, desktopMestoBold);
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "bodySmallBold" variant, or add the classname "encore-text-body-small-bold"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('bodySmallBold')};
 * ```
 */
export var metronome = function metronome() {
  return responsiveVariant(mobileMetronome, desktopMetronome);
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "marginal" variant, or add the classname "encore-text-marginal"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('marginal')};
 * ```
 */
export var finale = function finale() {
  return responsiveVariant(mobileFinale, desktopFinale);
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "marginalBold" variant, or add the classname "encore-text-marginal-bold"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('marginalBold')};
 * ```
 */
export var finaleBold = function finaleBold() {
  return responsiveVariant(mobileFinaleBold, desktopFinaleBold);
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "marginal" variant, or add the classname "encore-text-marginal"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('marginal')};
 * ```
 */
export var minuet = function minuet() {
  return responsiveVariant(mobileMinuet, desktopMinuet);
};

/**
 * @deprecated
 * This mixin has been deprecated alongside the
 * {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs Type} component.
 *
 * Please use {@link https://encore.spotify.net/components/text Text} with the "marginalBold" variant, or add the classname "encore-text-marginal-bold"
 * to your custom component.
 *
 * You can import Encore's {@link https://ghe.spotify.net/encore/web/blob/29058429c51ea987b5a820de5d33b17af4b03d17/src/core/styles/layout-theme.tsx#L200 textClass}
 *  utility for type safety, e.g.:
 * ```
 * classname={textClass('marginalBold')};
 * ```
 */
export var minuetBold = function minuetBold() {
  return responsiveVariant(mobileMinuetBold, desktopMinuetBold);
};